export default __webpack_public_path__ + "static/7-8c06100b18577cd6e0af0b15dfce6ae6.webp";